import InformativeBox from './informative-box';

export default InformativeBox;
